import ModalConfirmation from './modal.confirmation.component'

export default ModalConfirmation
